import { RouteRecordRaw } from 'vue-router';
import { MenuItem } from '@/router/menuItem';
import { AppIcons } from '@/common';
import { isFeatureEnabled } from '@/router/featureFlags';

export const homeMenuItems: MenuItem[] = [
    {
        icon: AppIcons.map,
        text: 'Chart',
        to: { name: 'Map' },
    },
    {
        icon: 'mdi-magnify',
        text: 'Find',
        to: { name: 'Find' },
    },
    {
        icon: AppIcons.checklist,
        text: 'Tasks',
        to: { name: 'CatlTasks' },
        featureDisabled: !isFeatureEnabled('tasks'),
    },
    {
        icon: AppIcons.assets,
        text: 'Assets',
        to: { name: 'CatlAssets' },
        featureDisabled: !isFeatureEnabled('assets'),
    },
    {
        icon: AppIcons.contacts,
        text: 'Contacts',
        to: { name: 'CatlContacts' },
    },
    {
        icon: AppIcons.controlMeasures,
        text: 'Control Measures',
        to: { name: 'CatlControlMeasures' },
        featureDisabled: !isFeatureEnabled('controlMeasures'),
    },
    {
        icon: AppIcons.assets,
        text: 'Asset Types',
        to: { name: 'CatlAssetTypes' },
        featureDisabled: !isFeatureEnabled('assetTypes'),
    },
    {
        icon: AppIcons.assets,
        text: 'Sensor Types',
        to: { name: 'CatlSensorTypes' },
        featureDisabled: !isFeatureEnabled('sensorTypes'),
    },
    {
        icon: AppIcons.requests_for_collection,
        text: 'Request for Collection',
        to: { name: 'CatlRfc' },
        featureDisabled: !isFeatureEnabled('rfc'),
    },
    {
        icon: 'mdi-magnify-scan',
        text: 'Intel',
        to: { name: 'IntelSources' },
        featureDisabled: !isFeatureEnabled('intel'),
    },
    {
        icon: 'mdi-map-search-outline',
        text: 'JIPOE',
        to: { name: 'Jipoe' },
        featureDisabled: !isFeatureEnabled('jipoe'),
    },
    {
        icon: 'mdi-file-document-edit-outline',
        text: 'Plan Editor',
        to: { name: 'PlanEditor' },
    },
    {
        icon: 'mdi-waveform',
        text: 'Bellhop Acoustic',
        to: { name: 'Bellhop' },
    },
    // Jasco visualizer: the standalone /detections page was retired
    // 2026-09-09 in favour of the "Analysis Mode" swimlane on the main
    // chart (Layers menu → Analysis Mode).  Same data source
    // (chorus.jasco.{positionsAt,detectionsAt}); no duplicate SFC to
    // maintain.
    // Admin: system-level configuration + integration surfaces.  AIS and
    // STANAG-4817 used to be top-level entries; they moved in here because
    // they are configured once per operation rather than opened per-shift.
    {
        text: 'Admin',
        icon: 'mdi-shield-account',
        children: [
            {
                icon: 'mdi-account-multiple',
                text: 'Users',
                to: { name: 'Users' },
            },
            {
                icon: 'mdi-account-key',
                text: 'Permissions',
                to: { name: 'Permissions' },
            },
            {
                icon: 'mdi-ferry',
                text: 'AIS',
                to: { name: 'Ais' },
            },
            {
                icon: 'mdi-file-import-outline',
                text: 'STANAG-4857',
                to: { name: 'Stanag4617' },
            },
            {
                icon: 'mdi-layers-outline',
                text: 'Map Layers',
                to: { name: 'AdminMapLayers' },
            },
        ],
    },

    // Generally leave this commented out, but uncomment if you want to see the link to this
    // page which is purely to aid development of the icon code generation backend.
    // {
    //     to: { name: 'DevelopmentIconCodeGeneration' },
    //     text: 'DEVELOPMENT - Icon Code Generation',
    // },
    /*
    {
        text: 'Global Carrier Fleet',
        icon: AppIcons.fleet,

        children: [
            {
                to: { name: 'GlobalCarrierTypes' },
                cypressName: Ui.APP_MENU_BUTTON_CARRIER_TYPES,
                icon: AppIcons.carrierTypes,
                text: 'Carrier Types',
            },
            {
                to: { name: 'GlobalFleet' },
                cypressName: Ui.APP_MENU_BUTTON_FLEET,
                icon: AppIcons.fleet,
                text: 'Carrier Fleet',
            },
        ],
    },*/
];

export const HomeRoute: RouteRecordRaw[] = [
    {
        path: '/',
        component: () => import('@/home/TheHomePage.vue'),
        name: 'Home',
        meta: {
            guestFeatureAccess: true,
        },
    },
];
